import React, { useState, useEffect } from 'react';

const AbandonCycleModal = ({ show, isLoading, onConfirm, onCancel }) => {
    const [notes, setNotes] = useState('');

    useEffect(() => {
        if (show) setNotes('');
    }, [show]);

    if (!show) return null;

    const isValid = notes.trim().length > 0;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl p-6 max-w-md w-full shadow-xl border-2 border-red-200">
                <div className="flex items-center gap-3 mb-4">
                    <span className="material-icons text-red-500 text-3xl">cancel</span>
                    <h5 className="font-bold text-gray-800 mb-0">¿Abandonar cultivo?</h5>
                </div>

                <div className="mb-4 px-3 py-2 bg-red-50 border border-red-200 rounded-lg text-xs font-bold text-red-500">
                    Esta acción cancela el ciclo de forma permanente y no se puede deshacer. Las fases no se completarán automáticamente.
                </div>

                <div>
                    <label className="block font-semibold mb-1 text-sm">Razón del abandono <span className="text-red-500">*</span></label>
                    <textarea
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        rows={3}
                        required
                        className="block w-full p-2 border border-gray-300 rounded text-sm"
                    />
                </div>

                <div className="flex gap-3 justify-end mt-4">
                    <button
                        className="px-4 py-2 rounded-lg border border-gray-200 text-sm font-bold text-gray-600 hover:bg-gray-50"
                        onClick={onCancel}
                        disabled={isLoading}
                    >
                        Cancelar
                    </button>
                    <button
                        className="px-4 py-2 rounded-lg bg-red-500 text-white text-sm font-bold hover:bg-red-600 flex items-center gap-2 disabled:opacity-60"
                        onClick={() => onConfirm({ notes })}
                        disabled={isLoading || !isValid}
                    >
                        {isLoading
                            ? <>
                                <span className="material-icons text-sm animate-spin">refresh</span>
                                Procesando...
                              </>
                            : <>
                                <span className="material-icons text-sm">delete_forever</span>
                                Sí, abandonar
                              </>
                        }
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AbandonCycleModal;
